(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/match-ticker/assets/javascripts/match-ticker.js') >= 0) return;  svs.modules.push('/widgets/match-ticker/assets/javascripts/match-ticker.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const buildEventDeepLink = svs.components.oddset.kambiOffering.buildEventDeepLink;
const EventState = svs.components.oddset.kambiOffering.common.constants.EventState;
const liveDataSubscribe = svs.components.oddset.kambiOffering.liveData.liveDataSubscribe;
const _window$DynamicMarque = window.DynamicMarquee,
  loop = _window$DynamicMarque.loop,
  Marquee = _window$DynamicMarque.Marquee;
const logger = svs.core.log.getLogger('widgets:match-ticker');
const TICKER_SCROLL_RATE_RUNNING = -50;
const TICKER_SCROLL_RATE_PAUSED = 0;
const FIFTEEN_MINUTES = 15 * 60 * 1000;
const TICKER_START_DELAY_MS = 1000;
const _svs$widget$match_tic = svs.widget.match_ticker.utils,
  generateEventConfig = _svs$widget$match_tic.generateEventConfig,
  addTrackingListener = _svs$widget$match_tic.addTrackingListener;
const createMarqueeEventItem = event => {
  const itemEl = document.createElement('a');
  addTrackingListener(itemEl, event);
  itemEl.classList.add('odds-deeplink');
  itemEl.href = buildEventDeepLink(event);
  const eventConfig = generateEventConfig(event);
  itemEl.innerHTML = svs.widget.match_ticker.templates.match_event(eventConfig);
  return itemEl;
};
const createUpdatedScore = event => {
  const itemEl = document.createElement('div');
  itemEl.classList = 'info-wrapper score';
  const eventConfig = generateEventConfig(event);
  itemEl.innerHTML = svs.widget.match_ticker.templates.match_score(eventConfig);
  return itemEl;
};
const createUpdatedClock = event => {
  const itemEl = document.createElement('h4');
  itemEl.classList.add('match-ticker-item__startdate');
  const eventConfig = generateEventConfig(event);
  itemEl.innerHTML = svs.widget.match_ticker.templates.match_clock(eventConfig);
  return itemEl;
};
const updateLiveInfo = event => {
  const parentElement = document.querySelector(".match-ticker-item[data-eventid='".concat(event.id, "']"));

  const updatedScoreElement = createUpdatedScore(event);
  const scoreElement = parentElement === null || parentElement === void 0 ? void 0 : parentElement.querySelector('.score');
  if (scoreElement) {
    scoreElement.replaceWith(updatedScoreElement);
  }

  const updatedClockElement = createUpdatedClock(event);
  const clockElement = parentElement === null || parentElement === void 0 ? void 0 : parentElement.querySelector('.match-ticker-item__startdate');
  if (clockElement) {
    clockElement.replaceWith(updatedClockElement);
  }
};
class MatchTicker {
  constructor(options) {
    var _this$options$model;
    this.options = options;
    this.el = options.$el[0];
    this.events = (_this$options$model = this.options.model) === null || _this$options$model === void 0 || (_this$options$model = _this$options$model.groups) === null || _this$options$model === void 0 ? void 0 : _this$options$model.events;
    this.subscriptions = null;
    this.isPaused = false;
    this.pendingSubscriptionInterval = null;
    this.serverTickerElement = this.el.querySelector('.server-rendered-ticker');
    this.setUpMarquee();
    this.startFetchingData();
  }
  setUpMarquee() {
    const renderedTicker = this.el.querySelector('.server-rendered-ticker');
    const renderedTickerUl = this.el.querySelector('.server-rendered-ticker ul');
    const useMarquee = (renderedTicker === null || renderedTicker === void 0 ? void 0 : renderedTicker.clientWidth) <= (renderedTickerUl === null || renderedTickerUl === void 0 ? void 0 : renderedTickerUl.clientWidth) + 20;
    if (useMarquee) {
      this.serverTickerElement.remove();
      const shouldReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)") === true || window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;
      this.marquee = new Marquee(this.el, {
        rate: TICKER_SCROLL_RATE_PAUSED,
        startOnScreen: true
      });
      this.template = svs.widget.match_ticker.templates.match_event;
      this.control = loop(this.marquee, this.generateMatchItems());
      this.marqueeEl = this.marquee._$window;
      if (!shouldReduceMotion) {
        this.setupListeners(this.marqueeEl);
        this.startDelayTimeout = setTimeout(() => this.startTicker(), TICKER_START_DELAY_MS);
      }
    } else {
      const renderedEvents = this.serverTickerElement.querySelectorAll('.odds-deeplink');
      for (let index = 0; index < renderedEvents.length; index++) {
        const element = renderedEvents[index];
        addTrackingListener(element, this.events[index]);
      }
    }
  }
  startTicker() {
    this.marquee.setRate(TICKER_SCROLL_RATE_RUNNING);
    this.isPaused = false;
  }
  pauseTicker() {
    this.marquee.setRate(TICKER_SCROLL_RATE_PAUSED);
    this.isPaused = true;
  }
  setupListeners(tickerEl) {
    if (svs.core.detect.formfactor.mobile()) {
      tickerEl.addEventListener('touchstart', () => {
        if (this.isPaused) {
          this.startTicker();
        } else {
          this.pauseTicker();
        }
      });
      document.addEventListener('click', () => {
        if (this.isPaused) {
          this.startTicker();
        }
      });
    } else {
      this.marqueeEl.addEventListener('mouseenter', () => {
        this.pauseTicker();
      });
      this.marqueeEl.addEventListener('mouseleave', () => {
        this.startTicker();
      });
      this.marqueeEl.addEventListener('focusin', () => {
        this.pauseTicker();
      });
      this.marqueeEl.addEventListener('focusout', () => {
        this.startTicker();
      });
    }
  }
  generateMatchItems() {
    return this.events.map((_, i) => () => createMarqueeEventItem(this.events[i]));
  }
  onLiveDataError(error) {
    logger.warn("Error in match-ticker ".concat(error === null || error === void 0 ? void 0 : error.message));
  }
  onLiveDataUpdate(newData) {
    this.setUpMarquee();
    const newDataEventId = newData.id || newData.eventId; 
    const activeEventIndex = this.events.findIndex(event => event.id === newDataEventId);
    if (activeEventIndex !== -1) {
      this.events[activeEventIndex] = _objectSpread(_objectSpread({}, this.events[activeEventIndex]), newData);

      updateLiveInfo(this.events[activeEventIndex]);
    }
  }
  async startFetchingData() {
    var _this$events;
    if (!((_this$events = this.events) !== null && _this$events !== void 0 && _this$events.length)) {
      return;
    }
    let nonSubscribedEvents = [];
    this.subscriptions = this.events.map(event => {
      if (event.state === EventState.STARTED) {
        return liveDataSubscribe(event.id, this.onLiveDataUpdate.bind(this), this.onLiveDataError.bind(this));
      }
      if (dateFns.differenceInMinutes(new Date(event.start), new Date()) <= 30) {
        return liveDataSubscribe(event.id, this.onLiveDataUpdate.bind(this), this.onLiveDataError.bind(this));
      }
      nonSubscribedEvents.push(event);
      return null;
    });
    if (nonSubscribedEvents.length > 0) {
      this.pendingSubscriptionInterval = setInterval(() => {
        const stillPending = [];
        nonSubscribedEvents.forEach(event => {
          if (dateFns.differenceInMinutes(new Date(event.start), new Date()) <= 30) {
            const subscription = liveDataSubscribe(event.id, this.onLiveDataUpdate.bind(this), this.onLiveDataError.bind(this));
            const eventIndex = this.events.findIndex(e => e.id === event.id);
            if (eventIndex !== -1) {
              this.subscriptions[eventIndex] = subscription;
            }
          } else {
            stillPending.push(event);
          }
        });
        nonSubscribedEvents = stillPending;
        if (nonSubscribedEvents.length === 0) {
          clearInterval(this.pendingSubscriptionInterval);
          this.pendingSubscriptionInterval = null;
        }
      }, FIFTEEN_MINUTES);
    }
  }
}
let instance;
setGlobal('svs.widget.match_ticker.init', options => {
  var _options$$el$;
  if (!(options !== null && options !== void 0 && (_options$$el$ = options.$el[0]) !== null && _options$$el$ !== void 0 && (_options$$el$ = _options$$el$.dataset) !== null && _options$$el$ !== void 0 && _options$$el$.initialized)) {
    instance = new MatchTicker(options);
    setGlobal('svs.widget.match_ticker.instance', instance);
    options.$el[0].dataset.initialized = 'true';
    if (svs.core.detect.feature('ft-oddset-ticker-debug-tools')) {
      svs.widget.match_ticker.setUpDevPanel();
    }
  }
});

 })(window);